$(document).on('ready', function () {
    (function () {
            const newsletterPopUpModal = $('#newsletter-popup-modal');
            const newsletterContentContainer = $('.newsletter-popup-content');
            const newsletterPopUpModalClose = $('.newsletter-popup-close-btn');

            if (window.location.pathname === '/' && newsletterPopUpModal.length) {

                // Check if user already submitted through the pop-up
                const isUserAlreadySubmitted = getItemWithExpiration('newsletterPopUp');

                if (!isUserAlreadySubmitted) {
                    setTimeout(function () {
                        newsletterPopUpModal.addClass('show');

                        // set expiration for 20 minutes
                        setItemWithExpiration('newsletterPopUp', true, 20);
                    }, 2000);
                }

                newsletterPopUpModalClose.on('click', function () {
                    newsletterPopUpModal.removeClass('show');
                });

                newsletterPopUpModal.on('click', function (e) {
                    if (e.target === this) {
                        newsletterContentContainer.addClass('scale-up-down');
                        setTimeout(function () {
                            newsletterContentContainer.removeClass('scale-up-down');
                        }, 1200)
                    }
                });
            }

            // Function to set an item in localStorage with an expiration date
            function setItemWithExpiration(key, value, expirationInMinutes) {
                const currentTime = new Date().getTime();
                const expirationTime = currentTime + expirationInMinutes * 60 * 1000; // Convert minutes to milliseconds
                const item = {
                    value: value,
                    expiration: expirationTime
                };
                localStorage.setItem(key, JSON.stringify(item));
            }

            // Function to get an item from localStorage with expiration handling
            function getItemWithExpiration(key) {
                const item = localStorage.getItem(key);
                if (!item) {
                    return null; // Item not found
                }

                const parsedItem = JSON.parse(item);
                const currentTime = new Date().getTime();

                if (parsedItem.expiration && currentTime >= parsedItem.expiration) {
                    localStorage.removeItem(key); // Remove expired item
                    return null; // Item has expired
                }

                return parsedItem.value;
            }
        }
    )();

});
